
export class RegisterationUserViewModel {
  public userName: string;
  public password: string;
}

export class RegistrationDataViewModel {
  public prefix: string;
  public name: string;
  public fname: string;
  public bday_ymd: number;
  public gender: number;
  public zip_code: string;
  public co: string;
  public address: string;
  public addition: string;
  public city: string;
  public country: string;
  public telephone1: string;
  public telephone2: string;
  public telephone_mobile: string;

}
